export var BookingsAutomationComponentIds;
(function (BookingsAutomationComponentIds) {
    /** let clients know that their appointment request has been approved */
    BookingsAutomationComponentIds["EMAIL_BOOK_APPROVED"] = "EMAIL_BOOK_APPROVED";
    /** let clients know that their appointment is pending confirmation */
    BookingsAutomationComponentIds["EMAIL_BOOK_PENDING"] = "EMAIL_BOOK_PENDING";
    /** let clients know that their appointment request has been declined */
    BookingsAutomationComponentIds["EMAIL_BOOK_DECLINED"] = "EMAIL_BOOK_DECLINED";
    /** notify clients when there's a change to their course */
    BookingsAutomationComponentIds["EMAIL_COURSE_CHANGE"] = "EMAIL_COURSE_CHANGE";
    /** notify clients of changes to their booked appointment or class */
    BookingsAutomationComponentIds["EMAIL_APPOINTMENT_OR_CLASS_CHANGE"] = "EMAIL_APPOINTMENT_OR_CLASS_CHANGE";
    /** send clients an email confirmation when they book */
    BookingsAutomationComponentIds["EMAIL_BOOKED_CONFIRM"] = "EMAIL_BOOKED_CONFIRM";
    /** remind clients about upcoming sessions */
    BookingsAutomationComponentIds["EMAIL_UPCOMING_REMINDER"] = "EMAIL_UPCOMING_REMINDER";
    /** notify clients when their booking is canceled */
    BookingsAutomationComponentIds["EMAIL_BOOK_CANCELED"] = "EMAIL_BOOK_CANCELED";
    /** send an email to clients who don't show */
    BookingsAutomationComponentIds["EMAIL_NO_SHOW"] = "EMAIL_NO_SHOW";
    /** let clients know their booking request has been approved */
    BookingsAutomationComponentIds["SMS_BOOK_APPROVED"] = "SMS_BOOK_APPROVED";
    /** let clients know their booking request is pending confirmation */
    BookingsAutomationComponentIds["SMS_BOOK_PENDING"] = "SMS_BOOK_PENDING";
    /** let clients know their booking request has been declined */
    BookingsAutomationComponentIds["SMS_BOOK_DECLINED"] = "SMS_BOOK_DECLINED";
    /** notify clients when there's a change to their course */
    BookingsAutomationComponentIds["SMS_COURSE_CHANGE"] = "SMS_COURSE_CHANGE";
    /** notify clients of changes to their booked appointment or class */
    BookingsAutomationComponentIds["SMS_APPOINTMENT_OR_CLASS_CHANGE"] = "SMS_APPOINTMENT_OR_CLASS_CHANGE";
    /** send clients an SMS confirmation when they book */
    BookingsAutomationComponentIds["SMS_BOOK_CONFIRM"] = "SMS_BOOK_CONFIRM";
    /** remind clients about upcoming sessions */
    BookingsAutomationComponentIds["SMS_UPCOMING_REMINDER"] = "SMS_UPCOMING_REMINDER";
    /** notify clients when their booking is canceled */
    BookingsAutomationComponentIds["SMS_BOOK_CANCELED"] = "SMS_BOOK_CANCELED";
})(BookingsAutomationComponentIds || (BookingsAutomationComponentIds = {}));
export var BookingsAutomationStatus;
(function (BookingsAutomationStatus) {
    /** unused */
    BookingsAutomationStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Automation will be triggered according to the trigger configuration */
    BookingsAutomationStatus["ACTIVE"] = "ACTIVE";
    /** Automation will not be triggered */
    BookingsAutomationStatus["INACTIVE"] = "INACTIVE";
})(BookingsAutomationStatus || (BookingsAutomationStatus = {}));
//# sourceMappingURL=types.impl.js.map